﻿import {DateTime} from "@2d-front-monorepo/core";

export function isAdjacentAcrossMidnight(endDate: DateTime, startDate: DateTime, unavailable?: Set<string>): boolean {
	const diffInMilliseconds = +startDate - +endDate;
	if (diffInMilliseconds === 1000) {
		return true;
	}

	const endTime = endDate.toTimeOnly();
	const startTime = startDate.toTimeOnly();
	if (endTime.getHours() !== 23 || endTime.getMinutes() !== 59 || endTime.getSeconds() !== 59) {
		return false;
	}

	if (startTime.getHours() !== 0 || startTime.getMinutes() !== 0 || startTime.getSeconds() !== 0) {
		return false;
	}

	const startDateOnly = startDate.toDateOnly();
	const endDateOnly = endDate.toDateOnly();
	let currentDay = endDateOnly.addDays(1);
	if (!unavailable) {
		return startDateOnly.equals(currentDay);
	}

	while (currentDay < startDateOnly) {
		if (!unavailable.has(currentDay.toString())) {
			return false;
		}

		currentDay = currentDay.addDays(1);
	}

	return true;
}
